/** Common allowed financial flow types */
export enum FinancialFlowTypeEnum {
  /** Incomes' flow */
  INCOME = 'INCOME',
  /** Expenses' flow */
  EXPENSE = 'EXPENSE',
}
